// @flow

const routes = {
  '/app/unsubscribe': {
    fetch: () =>
      import(
        /* webpackChunkName: 'unsubscribe-route' */ 'app/unsubscribe/asyncRoute'
      ).then(module => module.default),
  },
};

export default routes;
